import { render, staticRenderFns } from "./OrganisationUserForm.vue?vue&type=template&id=0b3063b7&scoped=true&"
import script from "./OrganisationUserForm.vue?vue&type=script&lang=js&"
export * from "./OrganisationUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3063b7",
  null
  
)

export default component.exports